<div class="primary">
  @if (isAct1) {
  <progress value="0" max="100"></progress>
  }
  <h1 [innerHtml]="heading | safeHtml"></h1>
  <p [class.is-dynamic]="!isAct1" [innerHtml]="subheading | safeHtml"></p>
  @if (!isAct1) {
  <a routerLink="/onboard" class="oneok-button oneok-aqua"><span>Request Company Access</span></a>
  }
</div>
@if (!isAct1) {
<div class="secondary" [class.is-clicked]="isShowingDetail">
  <div class="matrix">
    @for (feature of features; track feature.Title; let featureIdx = $index) {
    <button
      type="button"
      class="naked matrix__child"
      [class]="'matrix__child--' + ( featureIdx + 1 )"
      (click)="onSelectMatrixChild($event)"
    >
      <div class="matrix__child__content">
        <svg-icon [src]="feature.Icon" />
        <span class="label">{{ feature.Title }}</span>
        <svg-icon src="/assets/svg/arrow-down--thin.svg" />
      </div>
    </button>
    }
  </div>
  @if (isShowingDetail) {
  <section class="detail">
    @for (feature of features; track feature.Title; let featureIdx = $index) { @if (shownDetailIdx === featureIdx) {
    <div class="detail__child">
      <p [innerHtml]="feature.Perks[0] | safeHtml"></p>
    </div>
    } }
  </section>
  }
</div>
} @if (isAct1) { @for (breaker of breakers; track $index; let breakerIdx = $index) {
<div class="breaker" [class]="'breaker--' + ( breakerIdx + 1 )"></div>
} }
